import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail, Phone, MapPin } from "lucide-react";

const footerLinks = {
  solutions: [
    { label: "Revenue Management", href: "/revenue-management-hoteles" },
    { label: "Software RMS", href: "/software-rms" },
    { label: "Pricing Dinámico", href: "/pricing-dinamico" },
    { label: "Forecasting", href: "/forecasting-hotelero" },
  ],
  resources: [
    { label: "¿Qué es RevPAR?", href: "/revpar" },
    { label: "Blog", href: "/blog" },
  ],
  company: [
    { label: "Sobre Nosotros", href: "/#about" },
    { label: "Contacto", href: "/#demo-form" },
  ],
};

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#0A0A0A] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto container-padding py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <img
              src="https://zimoorevenue.com/wp-content/uploads/2024/08/logotipo.png"
              alt="Zimoo Revenue"
              className="h-10 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-gray-400 leading-relaxed mb-6 max-w-sm">
              Optimiza los ingresos de tu hotel con nuestra plataforma de Revenue Management impulsada por inteligencia artificial.
            </p>
            <div className="space-y-3">
              <a
                href="tel:+529981475384"
                className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors"
              >
                <Phone size={18} />
                <span>998 147 5384</span>
              </a>
              <a
                href="mailto:ventas@zimoorevenue.com"
                className="flex items-center gap-3 text-gray-400 hover:text-white transition-colors"
              >
                <Mail size={18} />
                <span>ventas@zimoorevenue.com</span>
              </a>
              <div className="flex items-center gap-3 text-gray-400">
                <MapPin size={18} />
                <span>Cancún, México</span>
              </div>
            </div>
          </div>

          {/* Solutions Column */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">
              Soluciones
            </h4>
            <ul className="space-y-3">
              {footerLinks.solutions.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Column */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">
              Recursos
            </h4>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-4">
              Empresa
            </h4>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="flex gap-4 mt-6">
              <a
                href="https://www.facebook.com/ZIMOOREVENUE"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#1ABCB4] transition-colors"
                data-testid="facebook-link"
              >
                <Facebook size={18} />
              </a>
              <a
                href="https://www.instagram.com/zimoorevenue"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#1ABCB4] transition-colors"
                data-testid="instagram-link"
              >
                <Instagram size={18} />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto container-padding py-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Zimoo Revenue. Todos los Derechos Reservados.
          </p>
          <p className="text-gray-500 text-sm">
            +15 años de experiencia en Revenue Management Hotelero
          </p>
        </div>
      </div>
    </footer>
  );
}
